(() => {
  const mobile = window.matchMedia('(max-width: 989px)');
  const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

  window.EdenDeferMobileCinematic = (section, initialize) => {
    if ((!document.documentElement.classList.contains('eden-homepage') &&
         !document.documentElement.classList.contains('eden-product-page')) ||
        !mobile.matches || !window.IntersectionObserver ||
        section.dataset.mobileCinematicEntered === 'true') return false;
    if (reducedMotion.matches) return true;
    if (section.dataset.mobileCinematicPending === 'true') return true;

    section.dataset.mobileCinematicPending = 'true';
    const observer = new IntersectionObserver(entries => {
      if (!entries.some(entry => entry.isIntersecting)) return;
      observer.disconnect();
      section.dataset.mobileCinematicEntered = 'true';
      delete section.dataset.mobileCinematicPending;
      if (!section.isConnected || reducedMotion.matches) return;
      if (window.EdenEnsureHomepageMotion) {
        window.EdenEnsureHomepageMotion().then(initialize).catch(() => {});
      } else {
        initialize();
      }
    }, { rootMargin: '0px 0px 80px 0px', threshold: 0 });
    observer.observe(section);
    return true;
  };

  function initializeBackgrounds() {
    if (!mobile.matches || !window.IntersectionObserver) {
      document.querySelectorAll('[data-luxury-section]').forEach(section => section.classList.add('is-mobile-background-ready'));
      return;
    }
    const backgrounds = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        if (!entry.isIntersecting) return;
        entry.target.classList.add('is-mobile-background-ready');
        backgrounds.unobserve(entry.target);
      });
    }, { rootMargin: '600px 0px', threshold: 0 });
    document.querySelectorAll('[data-luxury-section="sec-three"], [data-luxury-section="sec-four"], [data-luxury-section="sec-five"]').forEach(section => backgrounds.observe(section));
  }
  document.addEventListener('DOMContentLoaded', initializeBackgrounds);
  document.addEventListener('shopify:section:load', initializeBackgrounds);
})();
